import toastr from "toastr";

export default {
  show(type, msg) {
    toastr.options.preventDuplicates = true;
    toastr.options.progressBar = true;
    toastr.options.closeButton = true;
    toastr.options.closeHtml = '<button><i class="icon-off"></i></button>';
    toastr.options.escapeHtml = true;
    toastr.options.extendedTimeOut = 0;
    toastr.options.timeOut = 5000;
    toastr.options.fadeOut = 250;
    toastr.options.fadeIn = 250;

    toastr[type](msg);
  },
  clear() {
    toastr.clear();
  },
};
